define('lq/events/actions/federatedLogin',[
    'lq',
    'lq/events/actions/eventAction',
    'lq/guidChecker'
], function (lq, EventAction, guidChecker) {
    'use strict';

    function FederatedLogin(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(FederatedLogin, EventAction);

    FederatedLogin.typeName = 'FederatedLogin';

    FederatedLogin.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    var getParameterByName = function (parameterName) {
        parameterName = parameterName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + parameterName + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null)
            return "";
        else
            return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    FederatedLogin.prototype.execute = function (continuation) {
        var commandId = getParameterByName('federatedLoginCommandId');

        // Prevent loop when this is called during PageLoad
        if (!window.isFederatedLoginAfterPageLoad && this.eventData.command === commandId) {
            continuation();
            return;
        }

        //deliberately not calling continuation(), because it makes no sense to continue event execution after a login/redirect

        var url = lq.getTenantUrl('FederatedLogin/Login'
            + '?commandId=' + encodeURIComponent(this.eventData.command)
            + '&actionId=' + encodeURIComponent(this.piping.actionId)
            + '&parameters=' + encodeURIComponent(JSON.stringify(this.piping.parameters.getNonSystemParameters()))
            + '&returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search));

        window.location.href = url;
    };

    FederatedLogin.prototype.handleError = function (eventName, defaultMessage, continuation, eventArg) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation, eventArg);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    FederatedLogin.afterPageLoad = function (eventing) {
        window.isFederatedLoginAfterPageLoad = true;

        var commandId = getParameterByName('federatedLoginCommandId');
        var status = getParameterByName('federatedLoginStatus');
        var returnUrl = getParameterByName('ReturnUrl');
        var userId = getParameterByName('federatedLoginUserId');
        var eventsToExecute = getParameterByName('federatedLoginEvents');

        if ((!commandId || !status)) return;

        var continuation = function () { };
        var commandWasFound = false;

        _.each(eventing.events.handlers, function (event) {
            _.each(event.actions, function (eventAction) {
                if (commandWasFound) return;

                if (commandId) {
                    if (eventAction.command === commandId) {
                        commandWasFound = true;

                        var handler = new FederatedLogin(eventAction);
                        handler.piping = eventing.piping;
                        handler.rootDrop = eventing.eventActionFactory.rootDrop;
                        handler.getEventActionIdentifier = $.noop;

                        if (status === 'Success') {
                            returnUrl = returnUrl || lq.getTenantUrl('');
                            if (!guidChecker.isGuidAndNotEmpty(handler.piping.parameters.getValue('CurrentUser'))) {
                                if (handler.eventIsEnabled('invalidCredentials'))
                                    handler.triggerEvent('invalidCredentials', continuation, returnUrl);
                            } else {
                                if (handler.eventIsEnabled('userLoggedIn')) {
                                    handler.triggerEvent('userLoggedIn', continuation, returnUrl);
                                } else {
                                    window.location = returnUrl;
                                }
                            }
                        } else if (status === 'InvalidCredentials')
                            handler.handleError('invalidCredentials',
                                'The credentials provided are invalid.',
                                continuation);
                        else if (status === 'UserLoginNotAllowed')
                            handler.handleError('userLoginNotAllowed',
                                'The user is not allowed to log in.',
                                continuation, userId);
                        else if (status === 'AccountLocked')
                            handler.handleError('accountLocked',
                                'Your acccount has been locked out because of too many invalid login attempts.',
                                continuation);
                        else
                            alert('Unable to login.');
                    }
                }
            });
        });
        if (eventsToExecute) {
            _.each(eventsToExecute.split(','), function (eventName) {
                eventing.publish(eventName, null, null, continuation, null);
            });
        }
    }

    return FederatedLogin;
});
